@if (first || (lastDate | date: 'd') !== (currentDate | date: 'd')) {
  <div class="my-3 flex items-center justify-center">
    <div class="flex-auto border-b border-b-gray-300"></div>
    <div class="text-secondary mx-4 flex-0 text-sm font-semibold leading-5">
      {{ (currentDate) | date: 'dd.MM.yyyy' }}
    </div>
    <div class="flex-auto border-b border-b-gray-300"></div>
  </div>
}
